import React from "react";
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

//Components
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "@nextome/nxtfooter";

//Actions
import { logout } from "../../redux/users/userActions";
import { setProject } from "../../redux/session/sessionActions";
import { setMenu } from "../../service/MenuManager";


export default function Layout() {

	let dispatch = useDispatch();
	let location = useLocation();
	let navigate = useNavigate();
	let project = useSelector(store => store.session.project);
	let user = useSelector(store => store.users.data);
	let menu = setMenu(user, project && project.projectTypeName);

	return (
		<div className="app">
			<Header logout={() => dispatch(logout())} project={project} user={user}
				changeProject={p => {dispatch(setProject(p)); navigate('/');}} />
			<div className="app-body">
				<Sidebar menu={menu || []} location={location} />
				<main className="main">
					<Container fluid>
						<Outlet />
					</Container>
				</main>
			</div>
			<Footer
				copyright={"Neetra srl"}
				copyrightLink={"https://www.neetra.com/"}
				signature={"Neetra"}
				signatureLink={"https://www.neetra.com/"}
			/>
		</div>
	);
}
